import { Ceremony } from './types';

// Tâches types du rétroplanning (libellés en français = clés de traduction).
// pos : place dans le parcours (0 = tout début, 1 = jour J) ; earliest / latest :
// bornes en mois avant le mariage ; status : prestataire ou préparatif dont la
// réponse retire la tâche (« Pas pour nous » ou déjà fait) ; cond : cérémonie requise.
export interface CatalogTask {
  key: string;
  label: string;
  tag: string;
  pos: number;
  earliest: number;
  latest: number;
  status?: string;
  cond?: Ceremony;
}

const task = (key: string, label: string, tag: string, pos: number, earliest: number, latest: number, status?: string, cond?: Ceremony): CatalogTask => ({ key, label, tag, pos, earliest, latest, status, cond });

export const CATALOG: CatalogTask[] = [
  // Toute première tâche (avant le lieu, à échéance égale) : retirée si des invités existent déjà
  task('invites', 'Faire la liste d’invités', 'Invités', 0, 24, 6),
  task('lieu', 'Réserver le lieu', 'Lieu', 0, 18, 6, 'lieu'),
  task('traiteur', 'Choisir et réserver le traiteur', 'Repas', 0.05, 14, 4, 'traiteur'),
  task('photo', 'Réserver le photographe', 'Photo', 0.08, 14, 4, 'photo'),
  task('video', 'Réserver le vidéaste', 'Photo', 0.1, 14, 4, 'video'),
  task('std', 'Envoyer les save the date', 'Invités', 0.12, 10, 4, 'std'),
  task('tenues', 'Trouver la robe et le costume', 'Tenues', 0.15, 12, 3, 'tenues'),
  task('musique', 'Réserver le DJ ou les musiciens', 'Animation', 0.2, 12, 3, 'musique'),
  task('officiant', 'Choisir l’officiant de la cérémonie laïque', 'Cérémonie', 0.2, 12, 3, 'officiant', 'laique'),
  task('eglise', 'Rencontrer le prêtre, préparation au mariage', 'Cérémonie', 0.2, 12, 3, 'eglise', 'religieuse'),
  task('fleurs', 'Choisir le fleuriste et la déco', 'Déco', 0.35, 9, 2, 'fleurs'),
  task('heberg', 'Bloquer des hébergements pour les invités', 'Invités', 0.35, 9, 2, 'heberg'),
  task('liste', 'Créer la liste de mariage', 'Invités', 0.4, 8, 2, 'liste'),
  task('fp-cmd', 'Commander les faire-part', 'Papeterie', 0.5, 7, 5, 'fairepart'),
  task('transport', 'Réserver le transport (voiture, navette)', 'Transport', 0.5, 6, 1.5, 'transport'),
  task('alliances', 'Choisir les alliances', 'Alliances', 0.55, 6, 1.5, 'alliances'),
  task('fp-send', 'Envoyer les faire-part', 'Papeterie', 0.6, 6, 4.5, 'fairepart'),
  task('beaute', 'Essais coiffure et maquillage', 'Beauté', 0.7, 4, 1, 'beaute'),
  task('menu', 'Dégustation et choix du menu', 'Repas', 0.7, 4, 1),
  task('musiques', 'Choisir les musiques des temps forts (cortège, entrée des mariés, dessert…)', 'Animation', 0.75, 3, 1.1),
  task('ceremonie', 'Écrire la cérémonie et les vœux', 'Cérémonie', 0.75, 4, 1, undefined, 'laique'),
  task('mairie', 'Déposer le dossier à la mairie', 'Démarches', 0.85, 3, 1, undefined, 'civil'),
  task('relance', 'Relancer les invités sans réponse', 'Invités', 0.85, 1.5, 0.75),
  task('plan', 'Finaliser le plan de table', 'Invités', 0.9, 1, 0.5),
  task('deroule', 'Préparer le déroulé du jour J', 'Jour J', 0.9, 1, 0.5),
  task('presta', 'Confirmer horaires et accès aux prestataires', 'Jour J', 0.97, 0.5, 0.3),
  task('essayage', 'Dernier essayage des tenues', 'Tenues', 0.97, 0.5, 0.3),
  task('soldes', 'Préparer les soldes à régler le jour J', 'Budget', 0.98, 0.25, 0.1),
  task('veille-alliances', 'Confier les alliances aux témoins', 'Jour J', 1, 0.03, 0.03),
  task('veille-repos', 'Se reposer et éviter le stress', 'Jour J', 1, 0.03, 0.03),
  // Tâches du mode « pas à pas »
  task('chaussures', 'Acheter les chaussures et accessoires', 'Tenues', 0.6, 4, 1.5),
  task('essayage2', 'Deuxième essayage de la robe', 'Tenues', 0.8, 2, 1.1),
  task('temoins', 'Briefer les témoins sur leurs rôles', 'Jour J', 0.88, 1, 0.6),
  task('recup-alliances', 'Récupérer les alliances', 'Alliances', 0.9, 1, 0.6),
  task('confirm-nombres', 'Confirmer les nombres aux prestataires', 'Jour J', 0.95, 0.5, 0.3),
  task('imp-menus', 'Imprimer les menus', 'Papeterie', 0.95, 0.5, 0.3),
  task('imp-plan', 'Imprimer le plan de table', 'Papeterie', 0.98, 0.25, 0.1),
  task('imp-prenoms', 'Imprimer les prénoms pour la déco de table', 'Papeterie', 0.98, 0.25, 0.1),
  task('beaute-fin', 'Dernier rendez-vous beauté (manucure, épilation)', 'Beauté', 0.98, 0.25, 0.1),
];

// Grandes étapes (vue d'ensemble) et tâches ajoutées en « pas à pas »
export const CORE = ['invites', 'veille-alliances', 'veille-repos', 'lieu', 'traiteur', 'photo', 'tenues', 'musique', 'officiant', 'eglise', 'fp-send', 'alliances', 'menu', 'mairie', 'plan', 'presta'];
export const DETAILED = ['chaussures', 'essayage2', 'temoins', 'recup-alliances', 'confirm-nombres', 'imp-menus', 'imp-plan', 'imp-prenoms', 'beaute-fin'];

// Tâches qui dépendent d'un prestataire sans en être la réservation
export const NEEDS: Record<string, string> = { menu: 'traiteur', 'imp-menus': 'traiteur', 'confirm-nombres': 'traiteur', 'imp-prenoms': 'fleurs' };

// Tâches « à tout moment » pour qu'aucune période ne reste vide
export const FLEX: Array<[string, string, string]> = [
  ['flex-budget', 'Faire le point sur le budget', 'Budget'],
  ['flex-invites', 'Compléter la liste d’invités', 'Invités'],
  ['flex-inspi', 'Rassembler vos inspirations (couleurs, déco)', 'Déco'],
  ['flex-temoins', 'Choisir vos témoins', 'Jour J'],
  ['flex-site', 'Personnaliser votre page d’invitation', 'Invités'],
  ['flex-reponses', 'Faire le point sur les réponses', 'Invités'],
  ['flex-playlist', 'Commencer la playlist', 'Animation'],
  ['flex-animations', 'Imaginer les animations pour les invités', 'Animation'],
  ['flex-cadeaux', 'Choisir les cadeaux invités', 'Déco'],
  ['flex-transport', 'Organiser les trajets des invités', 'Invités'],
];

// Idées proposées à l'ajout d'une tâche, en plus du catalogue
export const EXTRA_IDEAS: CatalogTask[] = [
  task('x-photobooth', 'Réserver un photobooth', 'Animation', 0.5, 8, 2),
  task('x-livre', 'Prévoir un livre d’or', 'Déco', 0.7, 4, 1),
  task('x-discours', 'Préparer vos discours', 'Jour J', 0.9, 2, 0.3),
  task('x-enfants', 'Prévoir une animation pour les enfants', 'Invités', 0.6, 6, 1),
];

export const catalogTask = (key: string | null) => CATALOG.find((c) => c.key === key) ?? EXTRA_IDEAS.find((c) => c.key === key) ?? null;
